module.exports = __webpack_public_path__ + "img/section3_icon3.6a481734.png";